// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"6584db0f","232":"b315cff4","237":"d77df342","526":"09902519"}[chunkId] + ".chunk.js";
};